import { createReducer } from '@reduxjs/toolkit';
import type { IDrawing } from 'types/IDrawing';
import { fetchDrawings, fetchDrawing, createDrawing, updateDrawing, deleteDrawing } from 'store/actions/drawingActions';

export interface DrawingState {
  drawings: IDrawing[];
  selectedDrawing: IDrawing | null;
  loading: boolean;
  error: string | null;
}

const initialState: DrawingState = {
  drawings: [],
  selectedDrawing: null,
  loading: false,
  error: null,
};

const drawingReducer = createReducer<DrawingState>(initialState, (builder) => {
  builder
    .addCase(fetchDrawings.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchDrawings.fulfilled, (state, action) => {
      state.loading = false;
      state.drawings = action.payload;
    })
    .addCase(fetchDrawings.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || 'Fehler beim Laden der Ziehungen';
    })
    .addCase(fetchDrawing.fulfilled, (state, action) => {
      state.selectedDrawing = action.payload;
    })
    .addCase(createDrawing.fulfilled, (state, action) => {
      state.drawings.push(action.payload);
    })
    .addCase(updateDrawing.fulfilled, (state, action) => {
      const index = state.drawings.findIndex((d) => d.id === action.payload.id);
      if (index >= 0) state.drawings[index] = action.payload;
      if (state.selectedDrawing?.id === action.payload.id) state.selectedDrawing = action.payload;
    })
    .addCase(deleteDrawing.fulfilled, (state, action) => {
      state.drawings = state.drawings.filter((d) => Number(d.id) !== action.meta.arg);
    });
});

export default drawingReducer;
